export default "__VITE_ASSET__C69RyHNG__"